export default __webpack_public_path__ + "static/media/Project02.a08fb003.jpg";